<template>
  <div class="lang lang__wrapper no-weglot">
    <img src="@/assets/svg/Group 8.svg" alt="" />
    <b-dropdown size="lg" variant="link" menu-class="lang__menu" right toggle-class="lang__popup text-decoration-none" no-caret>
      <template #button-content>
        <div class="no-weglot">{{ currentLang.toUpperCase() }}</div>
      </template>

      <b-dropdown-item link-class="lang__link" href="#" v-for="(lang, index) in languages" :key="index">
        <div class="lang__text no-weglot" :class="[currentLang == lang.code ? 'current' : '']" v-on:click="changeLang(lang.code)">
          <p class="m-0" style="text-transform: capitalize">{{ lang.name }}</p>
          <p class="lang__check m-0"><img src="@/assets/svg/check (3).svg" alt="" /></p>
        </div>
      </b-dropdown-item>

      <!-- <b-dropdown-item link-class="lang__link" href="#">
        <div class="lang__text no-weglot" :class="[currentLang == 'fr' ? 'current' : '']" v-on:click="changeLang('fr')">
          <p class="m-0">Francois</p>
          <p class="lang__check m-0"><img src="@/assets/svg/check (3).svg" alt="" /></p>
        </div>
      </b-dropdown-item>
      <b-dropdown-item link-class="lang__link" href="#">
        <div class="lang__text no-weglot" :class="[currentLang == 'es' ? 'current' : '']" v-on:click="changeLang('es')">
          <p class="m-0">Español</p>
          <p class="lang__check m-0"><img src="@/assets/svg/check (3).svg" alt="" /></p>
        </div>
      </b-dropdown-item>
      <b-dropdown-item link-class="lang__link" href="#">
        <div class="lang__text no-weglot" :class="[currentLang == 'de' ? 'current' : '']" v-on:click="changeLang('de')">
          <p class="m-0">Deutsch</p>
          <p class="lang__check m-0"><img src="@/assets/svg/check (3).svg" alt="" /></p>
        </div>
      </b-dropdown-item> -->
    </b-dropdown>

    <img src="@/assets/svg/chevron-down (2).svg" alt="" />
  </div>
</template>

<script type="text/javascript" src="https://cdn.weglot.com/weglot.min.js"></script>

<script>
import { mapState, mapActions } from 'vuex'
export default {
  name: 'cWeglot',
  data() {
    return {
      languages: [],
    }
  },
  computed: {
    ...mapState(['currentLang']),
  },
  created() {
    let change = false
    this.languages.push({
      code: 'en',
      name: 'english',
    })
    Weglot.options.languages.forEach((language) => {
      if (Weglot.getCurrentLang() == language.language_to) {
        change = true
      }
      this.languages.push({
        code: language.language_to,
        name: this.getLangName(language.language_to),
      })
    })

    if (change) {
      this.changeLanguage(Weglot.getCurrentLang())
    }
  },
  methods: {
    ...mapActions(['changeLanguage']),
    changeLang(lang) {
      this.changeLanguage(lang)
      Weglot.switchTo(lang)
      console.log('Weglot.switchTo', lang, this.languages)
    },
    getLangName(lang) {
      return new Intl.DisplayNames([lang], {
        type: 'language',
      }).of(lang)
    },
  },
}
</script>

<style lang="scss">
.lang {
  // position: absolute;
  z-index: 10000;
  // top: 48px;
  // right: 59px;
  // right: 0px;
  &__wrapper {
    display: flex;
    justify-content: flex-end;
  }
  &__popup {
    padding: 10px;
  }
  &__menu {
    padding: 20px 13px;
    border: none;
    box-shadow: 0px 3px 6px #00000029;
  }
  &__link {
    padding: 0;
  }
  &__text {
    padding: 10px 10px 9px 10px;
    display: flex;
    justify-content: space-between;
    .lang__check {
      display: none;
    }
    &.current {
      background-color: #f3f3f3;
      .lang__check {
        display: block;
        img {
          height: 14px;
        }
      }
    }
  }
}
</style>
